import React from 'react';
import styled from 'styled-components';

/**
 * How the page looks pasted into WhatsApp, Facebook or LinkedIn — the summary_large_image
 * card the site emits. Shows the fallback state honestly: when no share image is set the
 * page uses its own cover image, which this panel cannot know, so it says so rather than
 * rendering a misleading empty card.
 */

const Container = styled.div`
  background: #fff;
  border: 1px solid #dadde1;
  border-radius: 8px;
  overflow: hidden;
  max-width: 500px;
  font-family: Helvetica, Arial, sans-serif;

  .image {
    width: 100%;
    aspect-ratio: 1.91 / 1;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8a8d91;
    font-size: 12px;
    text-align: center;
    padding: 0 24px;
    object-fit: cover;
  }

  img.image {
    display: block;
  }

  .body {
    padding: 10px 12px;
    border-top: 1px solid #dadde1;
    background: #f2f3f5;
  }

  .domain {
    color: #606770;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .title {
    color: #1d2129;
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    margin-top: 3px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .description {
    color: #606770;
    font-size: 13px;
    line-height: 18px;
    margin-top: 3px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .placeholder {
    color: #8a8d91;
    font-style: italic;
  }
`;

export interface OgCardPreviewProps {
  title?: string | null;
  description?: string | null;
  imageUrl?: string | null;
}

const OgCardPreview = ({ title, description, imageUrl }: OgCardPreviewProps) => (
  <Container>
    {imageUrl ? (
      <img className="image" src={imageUrl} alt="" />
    ) : (
      <div className="image">
        No share image set — the page will fall back to its own cover image
      </div>
    )}
    <div className="body">
      <div className="domain">ancana.co</div>
      <div className="title">
        {title || <span className="placeholder">No title</span>}
      </div>
      <div className="description">
        {description || <span className="placeholder">No description</span>}
      </div>
    </div>
  </Container>
);

export default OgCardPreview;
